/* istanbul ignore file */
import { stringify } from "query-string";

import { mainApi } from "config/api";
import { getClientFor } from "infrastructure/http";

import { IEnterprisesRequest, IEnterprisesResponse } from "./Enterprise.api.types";

export const getEnterprises = async (request: IEnterprisesRequest): Promise<IEnterprisesResponse[]> => {
  return (
    await getClientFor(mainApi.name).get<IEnterprisesResponse[]>("/organizations/enterprises/accounts/me", {
      params: request,
      paramsSerializer: p => {
        return stringify(p);
      }
    })
  ).data;
};
